import React from 'react';
import PropTypes from 'prop-types';
import AllhomesShareButton from './allhomes-share-button';
import * as styles from './allhomes-share-buttons.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesShareButtons = props => {
  var _props$print, _props$email, _props$print2, _props$email2;
  var ButtonMap = {
    print: {
      type: 'print',
      hasHref: true,
      href: (_props$print = props.print) === null || _props$print === void 0 ? void 0 : _props$print.link,
      hasTitle: false,
      hasMedia: false
    },
    email: {
      type: 'email',
      hasHref: true,
      href: (_props$email = props.email) === null || _props$email === void 0 ? void 0 : _props$email.link,
      hasTitle: false,
      hasMedia: false
    },
    facebook: {
      type: 'facebook',
      hasHref: false,
      hasTitle: false,
      hasMedia: false
    },
    twitter: {
      type: 'twitter',
      hasHref: false,
      hasTitle: true,
      hasMedia: false
    },
    pinterest: {
      type: 'pinterest',
      hasHref: false,
      hasTitle: true,
      hasMedia: true
    }
  };
  var shareButtons = [];
  if ((_props$print2 = props.print) !== null && _props$print2 !== void 0 && _props$print2.enabled) {
    shareButtons.push(ButtonMap.print);
  }
  if ((_props$email2 = props.email) !== null && _props$email2 !== void 0 && _props$email2.enabled) {
    shareButtons.push(ButtonMap.email);
  }
  if (props.facebook) {
    shareButtons.push(ButtonMap.facebook);
  }
  if (props.twitter) {
    shareButtons.push(ButtonMap.twitter);
  }
  if (props.pinterest) {
    shareButtons.push(ButtonMap.pinterest);
  }
  return ___EmotionJSX("div", {
    className: props.className,
    css: styles.shareButtons
  }, shareButtons.map((button, index) => ___EmotionJSX(AllhomesShareButton, {
    key: button.type,
    position: index + 1,
    type: button.type,
    href: button.hasHref ? button.href : undefined,
    title: button.hasTitle ? props.title : undefined,
    media: button.hasMedia ? props.media : undefined
  })));
};
AllhomesShareButtons.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  media: PropTypes.string,
  print: PropTypes.shape({
    enabled: PropTypes.bool,
    link: PropTypes.string.isRequired
  }),
  email: PropTypes.shape({
    enabled: PropTypes.bool,
    link: PropTypes.string.isRequired
  }),
  facebook: PropTypes.bool,
  twitter: PropTypes.bool,
  pinterest: PropTypes.bool
};
AllhomesShareButtons.defaultProps = {
  className: undefined,
  media: null,
  print: null,
  email: null,
  facebook: false,
  twitter: false,
  pinterest: false
};
export default AllhomesShareButtons;